// Tailwind only emits classes it sees as literals, so proportional bars snap
// to 5% steps from this list instead of using inline width styles.
const WIDTH_CLASSES = [
  'w-0',
  'w-[5%]',
  'w-[10%]',
  'w-[15%]',
  'w-[20%]',
  'w-[25%]',
  'w-[30%]',
  'w-[35%]',
  'w-[40%]',
  'w-[45%]',
  'w-[50%]',
  'w-[55%]',
  'w-[60%]',
  'w-[65%]',
  'w-[70%]',
  'w-[75%]',
  'w-[80%]',
  'w-[85%]',
  'w-[90%]',
  'w-[95%]',
  'w-full',
];

// Any non-zero value keeps a visible sliver so it never reads as "nothing".
const MIN_VISIBLE_CLASS = 'w-1';

export const barWidthClass = (value, max) => {
  if (!value || value <= 0 || !max || max <= 0) return WIDTH_CLASSES[0];
  const step = Math.round((Math.min(value, max) / max) * 20);
  return step === 0 ? MIN_VISIBLE_CLASS : WIDTH_CLASSES[step];
};
